import React, { lazy } from 'react';
const galleryImages = [{
  src: 'https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/SASS/CowboyAction.JPG',
  alt: 'Cowboy Action Shooting'
}, {
  src: 'https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/SASS/Cowboys.JPG',
  alt: 'Cowboys at FLSC'
}, {
  src: 'https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/SASS/CowboysBoy.JPG',
  alt: 'Young cowboy shooter'
}, {
  src: 'https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/SASS/Cowgirl.JPG',
  alt: 'Cowgirl shooter'
}, {
  src: 'https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/SASS/FLSC_BBB5.jpg',
  alt: 'FLSC Cowboy Action event'
}, {
  src: 'https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/SASS/SpecialUseRng.JPG',
  alt: 'Special Use Range'
}];
export function Gallery() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-875">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-876">
        <div className="mb-12" data-id="element-877">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-878">
            Gallery
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-879">
            {galleryImages.map(({
            src,
            alt
          }, index) => <div key={index} className="aspect-square rounded-xl overflow-hidden shadow-sm bg-gray-200 relative group" data-id="element-880">
                <img src={src} alt={alt} className="block w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" loading="lazy" data-id="element-881" />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300" data-id="element-882" />
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}